module.exports = __webpack_public_path__ + "img/io-4.9443cb93.jpg";